// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__lRdnG","container":"Sidebar_container__q0QgO","activeChatBox":"Sidebar_activeChatBox__-gmBf"};